// src/app/app.ts
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MemberNavbarPage } from './pages/member/navbar/member-navbar.page';
import { AuthStateService } from './services/MemberServices/LoginAndAuth/auth-state.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, MemberNavbarPage],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  /** expose the signal itself */
  readonly isLoggedIn = inject(AuthStateService).isLoggedIn;
}
